import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Parent Imports
const AnonUserHome = Loadable(lazy(() => import('views/anon-user/Home')));
const AnonUserSchools = Loadable(lazy(() => import('views/anon-user/Schools')));
const Profile = Loadable(lazy(() => import('views/common/Profile')));
const Account = Loadable(lazy(() => import('views/common/Account')));
const AboutUs = Loadable(lazy(() => import('views/authentication/authentication/AboutUs')));

// ==============================|| MAIN ROUTING ||============================== //

const AnonymousUserRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/home',
            element: <AnonUserHome />
        },
        {
            path: '/aboutus',
            element: <AboutUs />
        },
        {
            path: '/account',
            element: <Account />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/paypaisa149',
            element: <></>
        }
    ]
};

export default AnonymousUserRoutes;
